module.exports = {"440118001":"荔城街道","440118002":"增江街道","440118003":"朱村街道","440118004":"永宁街道","440118101":"新塘镇","440118102":"石滩镇","440118103":"中新镇","440118104":"正果镇","440118105":"派潭镇","440118106":"小楼镇","440118107":"仙村镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440118.json
// module id = 1955
// module chunks = 0